// extracted by mini-css-extract-plugin
export default {"btnWide":"Button_btnWide__jV+JW"};